import React from "react";
import { useMutation, useQuery } from "react-query";
import { useAuthContext } from "shared/context/auth-context";
import { client } from "shared/helpers/client";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup"
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { appendFormData, localize, stringify } from "shared/helpers/utils";
import { toast } from "react-toastify";
import { parsePhoneNumber } from "awesome-phonenumber";
import { useLookups } from "shared/hooks/use-lookups";

interface ProfileResponse {
  customerId: string,
  bankname: string,
  banknum: string,
  jobDescription: string,
  name: string,
  phone1: string,
  phone2: string,
  username: string,
  personalId:string,
  email:string,
  photo:File
}

interface ProfileData {
  customerNumber:string,
  customerName:string,
  customerPosition:string,
  customerPhone:string,
  alternativePhone:string,
  bankId:string,
  bankAccountNumber:string,
  username:string,
  personalId:string,
  email:string,
  photo:File
}

export function useProfile() {
  const {t} = useTranslation();
  const [{ user }] = useAuthContext();
  const {banks,jobDescriptions} = useLookups(['banks','job-description']);

  const {mutate:callChangeProfileServer,isLoading} = useMutation((data:any) => client('/Owner/UpdateOwnerProfile',{data}))


  const schema = React.useMemo(() => {
    return yup.object().shape({
      customerName: yup.string().required(t('errors.required'))
    });
  },[t])

  const methods = useForm<ProfileData>({
    resolver: yupResolver(schema),
    defaultValues: {
      customerPosition:'',
      bankId: '',
    },
  });

  const { data: profileData } = useQuery(
    ["profile"],
    () =>
      client<ProfileResponse>("/Owner/GetOwnerProfile").then((r) => r.response),
    {
      onSuccess(response) {
        methods.reset({
          customerNumber: response?.customerId,
          customerName: response?.name ?? '',
          customerPosition: response?.jobDescription,
          customerPhone: response?.phone1,
          alternativePhone:response?.phone2,
          email:response?.email,
          personalId: response?.personalId ?? '',
          username:response?.username,
          photo:response?.photo
        });
      },
    }
  );


  function changeProfileData(data:ProfileData) {
  const profileDataDto = {
    Name: data.customerName,
    jobDescription: data.customerPosition ?? '',
    personalId: data?.personalId ?? '',
    email:  data?.email ?? '',
    phone1: data.alternativePhone ?? '',
    phone2: data.customerPhone ?? '',
    photo: data?.photo 
  }
  const formData = appendFormData(profileDataDto)

callChangeProfileServer(formData,{
  onSuccess({response,error}) {
    if(response) toast.success(t('form.save-success'))
   // if(error) toast.error(t('errors.server-error'))
  }
})

  }



  return {profileData,...methods,handleSubmit: methods.handleSubmit(changeProfileData),isLoading,banks,jobDescriptions}
}
